import {
	DELIVERABLES as SET_DELIVERABLES,
	DRAFT_DELIVERABLES as SET_DRAFT_DELIVERABLES,
	DRAFT_ABTESTS,
	ACTIVE_ABTESTS,
	COMPLETED_ABTESTS,
	LISTED_DELIVERABLES_PER_PAGE as SET_LISTED_DELIVERABLES_PER_PAGE,
	LISTED_DELIVERABLES_PAGINATION as SET_LISTED_DELIVERABLES_PAGINATION,
} from "./actions";
import { LIST_AB_TESTS } from "assets/js/data/automations/types";

let initialState = () => {
	return {
		deliverables: null,
		draftDeliverables: null,
		draftABTests: null,
		activeABTests: null,
		sentABTests: null,
		perPage: 25,
		page: 1,
	};
};
import deepcopy from "deepcopy";
export const reducer = (state = initialState(), action) => {
	switch (action.type) {
	case SET_DELIVERABLES:
		return { ...state, deliverables: action.deliverables };
		break;
	case SET_DRAFT_DELIVERABLES:
		return { ...state, draftDeliverables: action.draftDeliverables };
	case DRAFT_ABTESTS:
		return { ...state, draftABTests: action.draftABTests };
	case ACTIVE_ABTESTS:
		return { ...state, activeABTests: action.abTests };
		break;
	case COMPLETED_ABTESTS:
		return { ...state, sentABTests: action.abTests };
		break;
	case SET_LISTED_DELIVERABLES_PER_PAGE:
		return { ...state, perPage: action.perPage, page: initialState().page };
		break;
	case SET_LISTED_DELIVERABLES_PAGINATION:
		return { ...state, page: action.page };
	case LIST_AB_TESTS: {
		const deep = deepcopy(action.data.active);
		return {
			...state,
			draftABTests: {
				data: [...action.data.drafts],
				pagination: { count: action.data.drafts.length },
			},
			activeABTests: action.data.active
				? {
					data: deep,
					pagination: { count: action.data.active.length },
					  }
				: null,
			sentABTests: action.data.completed
				? {
					data: [...action.data.completed],
					pagination: { count: action.data.completed.length },
					  }
				: null,
		};
	}
	default:
		return state;
		break;
	}
};
